import { useCallback, useEffect, useState } from 'react';

import type { TimeLeft } from './template';

/**
 * 인자로 받은 숫자가 10보다 작으면 앞에 0을 채우는 함수
 */
export function padZero(dateUnit: number) {
  if (dateUnit < 10) {
    return '0' + dateUnit;
  } else {
    return dateUnit;
  }
}

export const calculateTimeLeft = (endTime: Date | string): TimeLeft | null => {
  const now = new Date();
  if (typeof endTime === 'string') {
    endTime = new Date(endTime);
  }
  let timeDelta = +endTime - +now;
  if (timeDelta <= 0) {
    timeDelta = 0;
  }

  let timeLeft;
  const daysLeft = Math.floor(timeDelta / (1000 * 60 * 60 * 24));
  const hoursLeft = Math.floor((timeDelta / (1000 * 60 * 60)) % 24);
  const minutesLeft = Math.floor((timeDelta / (1000 * 60)) % 60);
  const secondsLeft = Math.floor((timeDelta / 1000) % 60);
  timeLeft = {
    days: daysLeft,
    hours: hoursLeft,
    minutes: minutesLeft,
    seconds: secondsLeft,
  };

  return timeDelta === 0 ? null : timeLeft;
};

export const useInterval = (
  callback: (...args: any[]) => any,
  delay: number,
) => {
  const call = useCallback(callback, [callback]);
  useEffect(() => {
    if (delay) {
      let id = setInterval(call, delay);
      return () => {
        clearInterval(id);
      };
    }
  }, [call, delay]);
};

export const useTimeLeft = (dDay: Date): TimeLeft => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(dDay));

  useInterval(() => {
    setTimeLeft(calculateTimeLeft(dDay));
  }, 1000);
  return timeLeft;
};
